const plans = {
  WLP_1099: {
    name: "Weight Loss Plan",
    amount: 1099,
    features: [
      "Fat-loss focused Indian diet",
      "Home / gym workout plan",
      "Portion & meal timing guide",
      "Weekly progress tracking",
      "Fat loss tips & common mistakes",
      "WhatsApp / email support",
    ],
  },
  BTP_999: {
    name: "Body Toning Plan",
    amount: 999,
    features: [
      "High-protein diet plan",
      "Strength & toning workouts",
      "Cardio + resistance balance",
      "Recovery & form guidance",
      "Basic progress tracking",
      "WhatsApp / email support",
    ],
  },
  LSP_999: {
    name: "Lifestyle Starter + Personal Training",
    amount: 999,
    features: [
      "Balanced Indian diet basics",
      "Light daily activity plan",
      "Habit & routine guidance",
      "Sleep & hydration tips",
      "Fitness tips with mindset support",
      "WhatsApp / email support",
    ],
  },
};

export default plans;
